import { ReactElement } from "react";
import Modify from "@shared/FormTemplates/Modify";
import ModifyForm from "./ModifyForm";
import updateItem from "@services/Clients/WhaleShark/hotv/updateItem";
import useGetDetailItem from "@hooks/Clients/WhaleShark/hotv/useGetHotv";
import validator from "@validators/Clients/WhaleShark/hotv/hotv.validate";
import formMapper from "@mappers/Clients/WhaleShark/hotv/HighlightItem.mapper";

const ModifyItem = (): ReactElement => (
  <Modify
    CustomForm={ModifyForm}
    modifyHook={updateItem}
    detailHook={useGetDetailItem}
    validator={validator}
    formMapper={formMapper}
  />
);

export default ModifyItem;
